"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FireIcon = exports.LightBulbIcon = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var asg_1 = require("@alinta-digital/asg");
var icons_1 = require("@alinta-digital/asg/icons");
var LightBulbIcon = function () { return (react_1.default.createElement(asg_1.Icon, { id: "fuelIcon", "data-testid": "iconLightBulb", icon: icons_1.Electricity, width: "27px", height: "45px" })); };
exports.LightBulbIcon = LightBulbIcon;
var FireIcon = function () { return react_1.default.createElement(asg_1.Icon, { id: "fuelIcon", "data-testid": "iconFire", icon: icons_1.Gas, width: "30px", height: "40px" }); };
exports.FireIcon = FireIcon;
//# sourceMappingURL=Icons.js.map